import React, { useState } from "react";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import styles from "../Login.module.scss";
import LoginLayout from "../LoginLayout";
import Button from "components/Button/Button";
import Form, {
  FormControl,
  FormFeedback,
  FormLabel,
  FormRow,
} from "components/Form/Form";
import Dialog, {
  DialogDescription,
  DialogTitle,
} from "components/Dialog/Dialog";
import AccountMigratedModal from "components/AccountMigratedModal/AccountMigratedModal";
import { resetPassword } from "services";

const LostPasswordSchema = Yup.object().shape({
  email: Yup.string().email("E-mail inválido").required("Campo obrigatório"),
});

export default function LostPassword() {
  const [showModal, setShowModal] = useState(false);
  const [apiErrors, setApiErrors] = useState([]);
  const [showAccountMigratedModal, setShowAccountMigratedModal] =
    useState(false);

  const institutionalDomains = [
    "@professor.edu.pi.gov.br",
    "@aluno.edu.pi.gov.br",
  ];

  const isInstitutionalEmail = (email) =>
    institutionalDomains.some((domain) => email.toLowerCase().endsWith(domain));

  const handleSubmit = async (values) => {
    const { email } = values;

    setApiErrors([]);
    const response = await resetPassword(email);

    if (response.status === 200) {
      toast.success("Link enviado para o email cadastrado");
      setShowModal(true);
      return;
    } else if (response.status === 404) {
      setApiErrors([
        "Esse email não está cadastrado na plataforma. Por favor, utilize o seu e-mail exclusivo da rede de ensino.",
      ]);

      if (!isInstitutionalEmail(email)) {
        setShowAccountMigratedModal(true);
      }
      return;
    }

    toast.error("Erro ao enviar o link");
  };

  return (
    <LoginLayout back="/entrar">
      <div className={styles.body}>
        <div className={styles.textGroup}>
          <h1 className={styles.title}>Insira seu email</h1>
          <p className={styles.description}>
            Insira o email que você cadastrou na plataforma e nós enviaremos um
            link para uma nova senha{" "}
          </p>
        </div>

        <Formik
          initialValues={{ email: "" }}
          validationSchema={LostPasswordSchema}
          onSubmit={async (values) => {
            try {
              await handleSubmit(values);
            } catch (error) {
              console.error(error);
            }
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <FormRow>
                <FormLabel htmlFor="email">Email</FormLabel>
                <FormControl
                  id="email"
                  name="email"
                  type="email"
                  onChange={(event) => {
                    setApiErrors([]);
                    props.handleChange(event);
                  }}
                  onBlur={props.handleBlur}
                  value={props.values.email}
                  invalid={
                    (props.errors.email && props.touched.email) ||
                    apiErrors.length > 0
                  }
                  placeholder="Insira seu e-mail"
                />
                <ErrorMessage name="email">
                  {(msg) => <FormFeedback invalid={true}>{msg}</FormFeedback>}
                </ErrorMessage>
                {apiErrors.map((error) => (
                  <FormFeedback key={error} invalid={true}>
                    {error}
                  </FormFeedback>
                ))}
              </FormRow>

              <Button modifiers={["primary", "full"]} type="submit">
                Enviar
              </Button>
            </Form>
          )}
        </Formik>

        <Dialog show={showModal} onClose={() => setShowModal(false)}>
          <DialogTitle>Verifique seu email de cadastro</DialogTitle>
          <DialogDescription>
            Enviamos um email com instruções sobre a nova senha. Verifique a
            caixa de entrada, pasta de spam e lixo eletrônico do seu email e
            siga os passos.
          </DialogDescription>
        </Dialog>

        <AccountMigratedModal
          isOpen={showAccountMigratedModal}
          onClose={() => setShowAccountMigratedModal(false)}
        />
      </div>
    </LoginLayout>
  );
}
